module.exports = "<ea-exchange-rate-page></ea-exchange-rate-page>\n"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaExchangeRate/eaExchangeRatePage/eaExchangeRatePageModule.html
// module id = 975
// module chunks = 12